"use client";

import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Location() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: coordsRef,
    isVisible: coordsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const coordinates = [{
    label: "LAT",
    value: "45.4642° N"
  }, {
    label: "LON",
    value: "9.1900° E"
  }, {
    label: "STUDIO",
    value: "MILANO"
  }, {
    label: "SPECIALIST",
    value: "GINECOLOGIA"
  }];
  const hours = [{
    day: "LUN — VEN",
    value: "SU APPUNTAMENTO"
  }, {
    day: "SABATO",
    value: "-"
  }, {
    day: "DOMENICA",
    value: "CHIUSO"
  }];
  return <section data-section-id="2891" id="dove-riceviamo" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="hidden lg:block absolute left-6 top-32 -rotate-90 origin-left">
        <span className="font-mono text-xs tracking-widest text-foreground/50 uppercase whitespace-nowrap">
          CONTATTI / 02
        </span>
      </div>

      <div className="container mx-auto max-w-7xl px-6 lg:px-12">
        {}
        <div ref={headerRef} className={`mb-16 transition-all duration-1000 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-12 bg-secondary" />
            <span className="font-mono text-xs tracking-widest uppercase text-secondary">
              STUDIO / SEDE
            </span>
          </div>
          <h2 className="font-default font-bold leading-[0.9] tracking-tight uppercase text-foreground" style={{
          fontSize: "clamp(4rem, 7vw, 6rem)"
        }}>DOVE<br />RICEVO</h2>
          <p className="font-default text-xl md:text-2xl text-muted-foreground mt-6 max-w-2xl">
            Riceviamo i pazienti in un ambiente riservato e professionale, dedicato alla salute della donna.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-10">
          {}
          <div ref={mapRef} className={`lg:col-span-3 transition-all duration-1000 delay-100 ${mapVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative border-[1.5px] border-border" style={{
            boxShadow: "12px 12px 0px 0px hsl(45 30% 50%)"
          }}>
              <div className="relative w-full aspect-[16/10] bg-muted overflow-hidden">
                {}
                <div className="absolute inset-0 opacity-40" style={{
                backgroundImage: "linear-gradient(hsl(215 15% 90%) 1px, transparent 1px), linear-gradient(90deg, hsl(215 15% 90%) 1px, transparent 1px)",
                backgroundSize: "40px 40px"
              }} />
                {}
                <svg className="absolute inset-0 w-full h-full opacity-30" viewBox="0 0 800 500" preserveAspectRatio="none" aria-hidden="true">
                  <path d="M0,100 Q200,80 400,150 T800,120" stroke="hsl(215 15% 80%)" strokeWidth="1" fill="none" />
                  <path d="M0,200 Q200,180 400,250 T800,220" stroke="hsl(215 15% 80%)" strokeWidth="1" fill="none" />
                  <path d="M0,300 Q200,280 400,350 T800,320" stroke="hsl(215 15% 80%)" strokeWidth="1" fill="none" />
                  <path d="M0,400 Q200,380 400,450 T800,420" stroke="hsl(215 15% 80%)" strokeWidth="1" fill="none" />
                  <path d="M100,0 Q200,150 150,300 T200,500" stroke="hsl(215 15% 80%)" strokeWidth="1" fill="none" />
                  <path d="M500,0 Q600,150 550,300 T600,500" stroke="hsl(215 15% 80%)" strokeWidth="1" fill="none" />
                </svg>

                {}
                <div className="absolute top-1/2 left-0 right-0 h-px bg-border/50" />
                <div className="absolute top-0 bottom-0 left-1/3 w-px bg-border/50" />

                {}
                <div className="absolute top-[42%] left-[38%] flex items-center gap-3">
                  <div className="size-6 bg-secondary flex items-center justify-center" style={{
                  boxShadow: "0 0 24px hsl(45 30% 50% / 0.6)"
                }}>
                    <MapPin className="size-3 text-white" strokeWidth={2.5} />
                  </div>
                  <span className="font-mono text-xs tracking-widest uppercase text-foreground bg-background/80 px-2 py-1">
                    STUDIO
                  </span>
                </div>

                {}
                <div className="absolute top-4 right-4 font-mono text-[10px] tracking-widest text-muted-foreground uppercase">
                  N ↑
                </div>
                <div className="absolute bottom-4 left-4 font-mono text-[10px] tracking-widest text-muted-foreground uppercase">
                  MILANO
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={cardRef} className={`lg:col-span-2 transition-all duration-1000 delay-200 ${cardVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="h-full border-[1.5px] border-border bg-card p-8 md:p-10 flex flex-col" style={{
            boxShadow: "0px 32px 48px -8px hsl(215 25% 12% / 0.1)"
          }}>
              {}
              <div>
                <div className="flex items-center gap-2 mb-4">
                  <div className="size-1.5 bg-secondary" />
                  <span className="font-mono text-xs tracking-widest uppercase text-secondary">
                    INDIRIZZO
                  </span>
                </div>
                <address className="font-default not-italic text-2xl leading-tight text-foreground space-y-1">
                  <div>Dott. Mirko Colloca</div>
                  <div>Presso "Studio Medico Moscati"<br />Via Pasquale De Maria, 43/B</div>
                  <div>89900 Vibo Valentia, VV</div>
                </address>
              </div>

              <Separator className="my-8 bg-border" />

              {}
              <div>
                <span className="font-mono text-xs tracking-widest uppercase text-muted-foreground block mb-4">
                  ORARI
                </span>
                <div className="space-y-2">
                  {hours.map((row, i) => <div key={i} data-index={i} className="flex items-baseline justify-between gap-4">
                      <span className="font-mono text-xs tracking-wider uppercase text-muted-foreground">
                        {row.day}
                      </span>
                      <span className="font-default text-lg text-foreground">
                        {row.value}
                      </span>
                    </div>)}
                </div>
              </div>

              <Separator className="my-8 bg-border" />

              {}
              <div className="flex-1">
                <span className="font-mono text-xs tracking-widest uppercase text-muted-foreground block mb-4">
                  INFORMAZIONI
                </span>
                <p className="font-default text-base leading-relaxed text-foreground/90">
                  Lo studio è facilmente raggiungibile con i mezzi pubblici. Si prega di prenotare la visita con anticipo per garantire la massima disponibilità.
                </p>
              </div>

              {}
              <div className="flex flex-col sm:flex-row gap-3 mt-10">
                <Button asChild className="flex-1 h-12 bg-primary text-white hover:bg-primary/90 font-default text-xs tracking-widest uppercase">
                  <Link to="/ContactsPage">
                    PRENOTA ORA
                    <ArrowRight className="size-4" />
                  </Link>
                </Button>
                <Button asChild variant="outline" className="flex-1 h-12 bg-transparent border-[1.5px] border-border text-foreground hover:bg-accent font-default text-xs tracking-widest uppercase">
                  <Link to="/ContactsPage">CONTATTI</Link>
                </Button>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="h-px bg-border mt-16 mb-6" />

        {}
        <div ref={coordsRef} className={`grid grid-cols-2 md:grid-cols-4 gap-6 transition-all duration-1000 delay-300 ${coordsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {coordinates.map((coord, i) => <div key={i} data-index={i} className="flex flex-col gap-1">
              <span className="font-mono text-[10px] tracking-widest uppercase text-muted-foreground">
                {coord.label}
              </span>
              <span className="font-mono text-sm tracking-wider uppercase text-foreground">
                {coord.value}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}